<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch26"></a><a id="page_27"></a><a href="#/contents#ch26"><b>Hail to the Chief</b></a></h2>
<p class="noindent"><span>To date, every U.S. president with a beard has been a Republican.</span></p>
<p class="noindent"><span>Only one person in ten is left-handed, but three of the past six presidents have been.</span></p>
<p class="noindent"><span>The first president to be impeached was Andrew Johnson.</span></p>
<p class="noindent"><span><i>Midnight Cowboy</i> was the only X-rated movie shown to a U.S. president (Jimmy Carter) in office.</span></p>
<p class="noindent"><span>All U.S. presidents have worn glasses, though some didn’t like wearing them in public.</span></p>
<p class="noindent"><span>William Henry Harrison is one of two presidents to have double letters in both his first and last names. The other: Millard Fillmore.</span></p>
<p class="noindent"><span>Presidential film screenings began in 1915, when Woodrow Wilson watched <i>The Birth of a Nation</i>.</span></p>
<p class="noindent"><span>Most common presidential religious affiliation: Episcopalian, followed by Presbyterian.</span></p>
<p class="noindent"><span>Presidential candidate who ran the most times: Socialist Norman Thomas, six times.</span></p>
<p class="noindent"><span>Candidate with the most electoral and popular votes: Ronald Reagan, in 1984.</span></p>
<p class="noindent"><span>The film Lyndon B. Johnson most often requested be shown in the White House while he was in office: a 10-minute short about himself.</span></p>
<p class="noindent"><span>Herbert Hoover was the last president whose term ended on March 3. They now end on January 20.</span></p>
<p class="noindent"><span>Last U.S. president with a mustache: William Howard Taft.</span></p>
<p class="noindent"><span>In 1963, Lyndon B. Johnson became the first Southerner to hold the office since Andrew Johnson in 1869.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter26.vue?0d26025c